import React from 'react';
import Button from "../button";
import _ from 'lodash';
import tickIcon from '../../assets/images/tick.gif';

const _getQuotePolicyOverviewRows = (policyOverview) => {
    const rows = [];

    const uniqByProduct = _.uniqBy(policyOverview, item => item.productId);

    const groupedByCategory =  _.groupBy(policyOverview, item => item.quotePolicyBenefit.category);

    _.forEach(groupedByCategory, (groupCategory, index) => {
        const singleRow = [];
        singleRow.push(<strong>{index}</strong>);
        _.forEach(uniqByProduct, pr => {singleRow.push('')});
        rows.push(singleRow);

        const groupedByBenefit = _.groupBy(groupCategory, item => item.quotePolicyBenefitId);

        _.forEach(groupedByBenefit, benefit => {
            const singleRow = [];
            try {
                singleRow.push(benefit[0]['quotePolicyBenefit']['name'])
            } catch (e) {
                singleRow.push('')
            }

            _.forEach(uniqByProduct, pr => {
                const match = _.find(benefit, item => {
                    return item.productId === pr.productId
                });
                if(match){
                    singleRow.push(<img src={tickIcon} />)
                } else {
                    singleRow.push('')
                }
            });


            rows.push(singleRow);

        });

        const emptyRow = [];
        emptyRow.push('');
        _.forEach(uniqByProduct, pr => {singleRow.push('')});
        rows.push(emptyRow);

    });

    return rows;
};

const QuotePolicyOverview = (props) => {
    const policyOverviewText = props._getQuoteMessageByPosition('QuickQuotePolicyOverviewProductsText');
    const rows = _getQuotePolicyOverviewRows(props.quotePolicyOverview);
    const headers = _.uniqBy(props.quotePolicyOverview, item => item.productId);
    return (
        <div>
            <div className={'row mt-15'}>
                <div className={'col-sm-12 table-responsive'}>
                    <table className={'table'}>
                        <thead>
                        <tr>
                            <th>
                                {'Policy benefits at a glance'}
                            </th>
                            {
                                headers.map((header, index) => {
                                    return (
                                        <th key={index}>
                                            {header.productName}
                                        </th>
                                    )
                                })
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {
                            rows.map((row, index) => {
                                return (
                                    <tr key={index}>
                                        {
                                            row.map((rowItem, index) => {
                                                return (
                                                    <td key={index}>
                                                        {rowItem}
                                                    </td>
                                                )
                                            })
                                        }
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className={'row'}>
                <div
                    className={'col-sm-12 mb-15'}
                    dangerouslySetInnerHTML={{__html: policyOverviewText.body}}
                >
                </div>
            </div>
            <div className={'row mt-15'}>
                <div className={'col-sm-12'}>
                    <Button
                        clickHandler={props._closePolicyOverviewModal}
                        wrapper="btn-wrapper"
                        btnType="button"
                        btnStyle={'btn btn-primary btn-xs sharp yellow'}
                        label="Close"
                    />
                </div>
            </div>
        </div>
    )
};

export default QuotePolicyOverview;